import { PreferenceFilterValue, PreferenceVisibleValue } from "../../../interfaces/Commons/Preferences/gridPreferences";

export const FilterColumnsGridMUI = () => {
    const GetFilterDefinitionByFilter = async (myArrayPreferences: PreferenceFilterValue[], isCustom: boolean = false): Promise<any> => {

        const transformedArray: PreferenceFilterValue[] = myArrayPreferences.map((item, index) => {
            return {
                idFilter: index + 1,
                column: item.column,
                operator: item.operator,
                value: item.value,
            };
        });

        return await transformedArray;
    };

    return {
        GetFilterDefinitionByFilter,
    }
}